import React from "react";
import ReactDOM from "react-dom/client";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store, persist } from "./store"; // Assuming you've modified your store as suggested
//import { datadogRum } from "@datadog/browser-rum";
//import { APP_VERSION } from "./utils/constants";
import cognitoAuthConfig from "./aws-exports";
import { AuthProvider } from "react-oidc-context";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ConfigProvider } from "antd";

const queryClient = new QueryClient();

/* datadogRum.init({
  applicationId: "3d0d9233-1e8c-4714-a483-501e37115129",
  clientToken: "puba884ebeaa9ad46a6d22688c448b8c92a",
  site: "us5.datadoghq.com",
  service: "meed-portal",
  env: "development",
  // Specify a version number to identify the deployed version of your application in Datadog
  version: APP_VERSION,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 100,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  allowFallbackToLocalStorage: true,
  defaultPrivacyLevel: "allow",
});

datadogRum.startSessionReplayRecording(); */

const root = ReactDOM.createRoot(document.getElementById("root")!); // Updated for React 18+

// Wrap your App component with the Provider and PersistGate
root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <BrowserRouter>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persist}>
            <QueryClientProvider client={queryClient}>
              <ConfigProvider
                theme={{
                  token: {
                    // Using the orange from your logo as the primary color
                    colorPrimary: "#e06932",
                    colorLink: "#e06932",
                    borderRadius: 6,
                  },
                }}
              >
                <App />
              </ConfigProvider>
            </QueryClientProvider>
          </PersistGate>
        </Provider>
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>,
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
